/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Country_Area_Manager_InvalidInputs */

const en_error_country_area_manager_invalid = /** @type {(inputs: Error_Country_Area_Manager_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The area manager of the country cannot be saved as it is:`)
};

/**
* | output |
* | --- |
* | "The area manager of the country cannot be saved as it is:" |
*
* @param {Error_Country_Area_Manager_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_country_area_manager_invalid = /** @type {((inputs?: Error_Country_Area_Manager_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Country_Area_Manager_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_country_area_manager_invalid(inputs)
});